<template>
    <div class="content-grid content-grid--subpage">
        <Breadcrumbs :title="t(`routes.admin.children.activities.${!isEditMode ? 'add' : 'update'}.name`)"/>
        <BackLinkTitle :title="t(`routes.admin.children.activities.${!isEditMode ? 'add' : 'update'}.name`)"/>
        <Card>
            <ActivityForm :id="props.id"/>
        </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import ActivityForm from '@/components/activities/ActivityForm.vue';
import {useI18n} from "vue3-i18n";
import {computed} from "vue";
import {Guid} from "@/types";

const {t} = useI18n()

// eslint-disable-next-line no-undef
const props = defineProps<{
    id?: string
}>()

const isEditMode = computed(() => props.id && Guid.isValid(props.id));
</script>
